import { render, staticRenderFns } from "./DocumentSection.vue?vue&type=template&id=cfc24dfe&scoped=true"
import script from "./DocumentSection.vue?vue&type=script&lang=js"
export * from "./DocumentSection.vue?vue&type=script&lang=js"
import style0 from "./DocumentSection.vue?vue&type=style&index=0&id=cfc24dfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc24dfe",
  null
  
)

export default component.exports